<template>
  <figure class="table-figure">
    <img class="border rounded" :src="getImage()" height="50" />
  </figure>
</template>

<script>
import get from "lodash/get";
export default {
  name: "MarketCartTableVariantImage",

  methods: {
    getImage() {
      const variantImage = get(this.data, `view.mp.ppl.image.image_thumb`);
      if (variantImage) {
        return variantImage;
      }
      const productImage = get(
        this.data,
        `view.mp.ppl.productproducer.image.image_thumb`
      );
      if (productImage) {
        return productImage;
      }

      return "/loonity/img/placeholder.svg";
    },
  },
};
</script>
